export default __webpack_public_path__ + "static/media/bannerGameplayRelease.cc632847.png";